var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',_vm._g(_vm._b({ref:"input",attrs:{"value":_vm.localValue,"outlined":"","single-line":"","color":"secondary","tabindex":"0","title":_vm.localValue},on:{"paste":_vm.onPaste}},'v-text-field',_vm.$attrs,false),_vm.inputListeners),[_vm._l((_vm.$slots),function(_,name){return _vm._t(name,null,{"slot":name})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }